'use client';
import { YellowButtonOutline } from '@/components/button/button';
import { Box, Container, GlobalStyles, Grid, Link, Stack, styled, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LearnMoreModal from './learn-more-modal';
import { sectionSpacingCss } from '../section-spacing';
import { config } from '@/config/environment';

const HeaderBox = styled(Box)`
  ${sectionSpacingCss}
  height: auto;
  margin: 0;
  position: relative;
  overflow: hidden;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ShareMomentsP = styled(Typography)`
  padding-top: 0vh;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 18px;
  line-height: 160%;
  color: #ffffff;
  text-align: center;
  margin-bottom: 30px;
  width: 100%;
  max-width: 550px;
  text-shadow:
    0 0 20px rgba(31, 21, 33),
    0 0 20px rgba(31, 21, 33),
    0 0 20px rgba(31, 21, 33);
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const LearnMore: React.FC<{ data?: any }> = ({ data }) => {
  const [open, setOpen] = useState(false);
  const archiveMode = config.platformMode === 'archive';

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);
  return (
    <HeaderBox justifyContent="center">
      {/* Left ellipse SVG behind content */}
      <Container
        maxWidth="lg"
        sx={{
          mx: 'auto',
          minHeight: '50px',
          position: 'relative',
          zIndex: 99,
        }}
      >
        <Stack spacing={2} alignItems="center" justifyContent="center">
          <ShareMomentsP>
            {archiveMode
              ? 'Curiko Coaches helped community members develop their own tools and strategies to create more of the moments they wanted in their lives.'
              : data?.heading ||
                `Test is one of Curiko’s core offerings. \nA Curiko Coach can help you come up with your own tools and strategies so that you get less of the moments you don’t want, and more of the moments you do.`}
          </ShareMomentsP>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <YellowButtonOutline label={data?.ctaLabel || 'Learn more'} onClick={openModal} />
          </Box>
          <LearnMoreModal open={open} onClose={closeModal} />
        </Stack>
      </Container>
    </HeaderBox>
  );
};
